import { render } from "./ButtonCopyClipboard.vue?vue&type=template&id=9cd2182e&scoped=true&ts=true"
import script from "./ButtonCopyClipboard.vue?vue&type=script&lang=ts"
export * from "./ButtonCopyClipboard.vue?vue&type=script&lang=ts"

import "./ButtonCopyClipboard.vue?vue&type=style&index=0&id=9cd2182e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cd2182e"]])

export default __exports__